/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dice_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roll 1d20 for a role-playing check.`)
};

const es_dice_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tira 1d20 para una tirada de rol.`)
};

const de_dice_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Würfle 1d20 für eine Rollenspiel-Probe.`)
};

const nl_dice_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gooi 1d20 voor een controle in een rollenspel.`)
};

const fr_dice_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancez 1d20 pour un test de jeu de rôle.`)
};

const it_dice_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancia 1d20 per una prova di gioco di ruolo.`)
};

const pt_br2_dice_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role 1d20 para um teste de RPG.`)
};

const pt_dice_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lance 1d20 para uma verificação de RPG.`)
};

const ja_dice_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロールプレイングの判定で1d20を振る。`)
};

const zh_dice_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`掷 1d20 进行角色扮演检定。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dice_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dice_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dice_ex2", locale)
	if (locale === "en") return en_dice_ex2(inputs)
	if (locale === "es") return es_dice_ex2(inputs)
	if (locale === "de") return de_dice_ex2(inputs)
	if (locale === "nl") return nl_dice_ex2(inputs)
	if (locale === "fr") return fr_dice_ex2(inputs)
	if (locale === "it") return it_dice_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_dice_ex2(inputs)
	if (locale === "pt") return pt_dice_ex2(inputs)
	if (locale === "ja") return ja_dice_ex2(inputs)
	return zh_dice_ex2(inputs)
};